module.exports = __webpack_public_path__ + "static/media/addToBag.48cd1433.png";